
















import Vue from 'vue';
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiTextFieldSimple from "./AsiTextFieldSimple";
import AsiTextField from "./AsiTextField";

@Component({
	components: {AsiTextField, AsiTextFieldSimple}
})
export default class AsiTimePicker extends Vue {

	@Prop({type: String, required: true})
	public label!: string;

	@Prop({default: null})
	public value!: string | null;

	@Prop({type: String})
	public max!: string;

	@Prop({type: String})
	public min!: string;

	@Prop({type: Boolean, default: false})
	public simple!: boolean;

	@Prop({type: Boolean, default: false})
	public clearable!: boolean;

	@Prop({type: Array, default: () => []})
	public rules!: (string | null | number | object | unknown | boolean)[];

	@Prop({type: Boolean, default: true})
	public autoClose!: boolean;

	@Prop({type: Boolean, default: false})
	public disabled!: boolean;

	@Prop({default: null})
	public allowedHours!: any;

	@Prop({default: null})
	public allowedMinutes!: any;

	protected menu: boolean = false;
	protected valueInternal: any = null;

	public created(): void {
	    this.updateValueInternal();
	}

	@Emit('change')
	public change(): any {
		//auto close
		if (this.autoClose && this.valueInternal !== null) {
			this.menu = false;
		}

		return this.valueInternal;
	}

	@Emit('input')
	public input(): Event {
		return this.valueInternal;
	}

	@Watch('value', {deep: true})
	private onValueChanged(): void {
		this.updateValueInternal();
	}

	private clear(): void {
		this.valueInternal = null;
		this.change();
	}

	private updateValueInternal(): void {
		this.valueInternal = this.value;
	}

}
